import React, { ReactElement } from "react";
import { TetherIcon } from "../../../components/ui/icons/adronIcons";
import IconComponent from "../../../components/ui/IconComponent";
import { InputAdornment } from "@mui/material";

interface AdornmentQuoteIconProps {
  quoteCurrencyName: string;
}

const AdornmentQuoteIcon = ({ quoteCurrencyName }: AdornmentQuoteIconProps) => {

  const renderIcon = (quoteIcon: string): ReactElement => {
    if (quoteIcon === "") return <></>;

    if (quoteIcon === 'USDT') return (
      <TetherIcon />
    );

    return (
      <IconComponent
        iconName={quoteIcon}
        type={'asBackground'}
        size={24}
      />
    )
  };

  return (
    <InputAdornment position="start">
      {renderIcon(quoteCurrencyName)}
    </InputAdornment>
  );
};

export default AdornmentQuoteIcon;